import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/data-breach";
export const organizationDataBreach = createCrudVuexModule({
  namespaced: true,
  path: path,
  options: {
    localizedFields: [
      "name",
      "description",
      "sourceAndType",
      "possibleEffect",
      "effectedSystems",
      "beforePolicies",
      "afterPolicies",
      "delayExcuse",
      "wantToDomesticInformationDescription",
      "wantToAbroadInformationDescription",
      "domesticInformation",
      "AbroadInformation",
    ],
  },
  state: {
    dataBreach: undefined,
    downloadingItem: [],
  },
  getters: {
    dataBreach: (state) => state.dataBreach,
    isDownloading: (state) => (id) => {
      return !state.downloadingItem.indexOf(id);
    },
  },
  mutations: {
    dataBreach: (state, value) => (state.dataBreach = value),
    addDownloadingItem: (state, id) => state.downloadingItem.push(id),
    removeDownloadingItem: (state, id) => {
      const index = state.downloadingItem.indexOf(id);
      state.downloadingItem.splice(index, 1);
    },
  },
  actions: {
    async fetchDetail({ getters, commit, dispatch }, id) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/data-breach/${id}`);
        commit("dataBreach", response.data);

        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
    async prepareWordExport({ commit }, id) {
      commit("isUpdating", true);
      try {
        commit("addDownloadingItem", id);
        const response = await rest.get(`/data-breach/export-word/${id}`);
        return response;
      } finally {
        commit("isUpdating", false);
        commit("removeDownloadingItem", id);
      }
    },
    async prepareExcelExport({ commit }, id) {
      commit("isUpdating", true);
      try {
        commit("addDownloadingItem", id);
        const response = await rest.post("/data-breach/export-excel");
        return response;
      } finally {
        commit("isUpdating", false);
        commit("removeDownloadingItem", id);
      }
    },
  },
});
